module.exports = __webpack_public_path__ + "img/r4.f9c41215.png";